__turbopack_context__.v({
  "checkbox": "licsfa_checkbox",
  "isSingleSelected": "licsfa_isSingleSelected",
  "isSmall": "licsfa_isSmall",
  "option": "licsfa_option",
});
